export interface QcJobItemMediaAudio {
    label: string;
    language: string;
    audioFileUrl: string;
    waveformUrl: string;
    createdAt: string;
    updatedAt: string;
    channels: [
      {
          waveformUrl: string;
          label: string
      }
    ]
}

export interface TimedText {
    language: string;
    type: string;
    jsonUrl: string;
    timedTextUrl: string;
    timedTextFormat: string;
}

export interface QcJobItemMedia {
    id: number;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
    thumbnails: string;
    blackFrames: string;
    adBreaks: string;
    markups: string;
    notes: string;
    videoFile: {
        id: number;
        url: string;
        dropFrame: boolean;
        frameRateLabel: string;
        framerateNumerator: number;
        framerateDenominator: number;
        totalRunTimeMilliseconds: string;
        createdAt: string;
        updatedAt: string;
    };
    audio: QcJobItemMediaAudio[];
    timedTexts: TimedText[];
}

export interface QcJobItemMediaAudioWaveform {
    data: string;
}

export interface IntervalParams {
    from: number;
    to: number;
}

export interface AudioWaveformParams extends IntervalParams {
    samples: number;
}

export interface ThumbnailParams extends IntervalParams {
    count: number;
}

export interface QcJobItemMediaTimedText {
    start: number;
    duration: number;
    value: string;
}

export type TimespanCategoryType = 'media' | 'metadata' | 'artwork' | 'rights' | 'markup';

export type ArtworkTypeToCreate = 'thumbnail_large' | 'thumbnail_small';

export enum TimespanMarkerType {
    AdBreak = 'AD_BREAK',
    BlackFrame = 'BLACK_FRAME',
    Note = 'NOTE',
    Markup = 'MARKUP',
}

export interface TimespanParams {
    start: number;
    end: number;
}

export interface ArtworkToCreate {
    artworkType: ArtworkTypeToCreate;
    left: number;
    right: number;
    top: number;
    bottom: number;
    width: number;
    height: number;
}

export type CreationArtworkBody = ArtworkToCreate[];

export interface TimespanNoteTypeParams extends TimespanParams {
    subtype: TimespanCategoryType;
}

export interface TimespanBody {
    startFrameNumber: number;
    durationFrames: number;
}

export interface TimespanNoteBody {
    startFrameNumber?: number | null,
    durationFrames?: number | null,
    timespanCategoryId?: number,
    value?: string,
    subtype: TimespanCategoryType,
}

export interface TimespanMarkupBody {
    startFrameNumber: number,
    durationFrames: number,
    timespanCategoryId?: number,
    subtype: TimespanCategoryType,
}

export interface TimespanMarkupUpdateBody {
    startFrameNumber?: number,
    durationFrames?: number,
    timespanCategoryId?: number,
    subtype?: TimespanCategoryType,
}

export interface TimespanCategory {
    id: number;
    label: string;
    type: TimespanCategoryType;
    group?: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
}

export interface CreatedOrUpdatedByUser {
    id: number;
    email: string;
    name: string;
}

export interface BaseTimespanMarker {
    id: number;
    type: TimespanMarkerType;
    createdAt: string;
    createdByUser: CreatedOrUpdatedByUser;
    createdByUserId: number;
    deletedAt: string | null;
    qcJobId: number;
    updatedAt: string;
    updatedByUser: {
        email: string;
        id: number;
        name: string;
    } | null;
    updatedByUserId: number | null;
    videoFileId: number;
    subtype: TimespanCategoryType;
    value: string | null;
    timespanCategoryId: number;
}

export interface TimespanMarker extends BaseTimespanMarker {
    startFrameNumber: number;
    durationFrames: number;
}

export interface TimespanAdBreak extends BaseTimespanMarker {
    startFrameNumber: number;
    durationFrames: number | null;
}

export interface TimespanNote extends BaseTimespanMarker {
    startFrameNumber: number | null;
    durationFrames: number | null;
}

export interface SrcDrawRect {
    x: number;
    y: number;
    width: number;
    height: number;
}

export interface Thumbnail {
    id: number;
    start: number;
    src: string;
    srcDrawRect?: SrcDrawRect;
}
